import {useEffect, useState} from "react";
import * as React from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {Badge, Button, Dialog, DialogContent, DialogTitle, Grid, IconButton, Stack, Typography} from "@mui/material";

import "./RegisterNoticeDialog.css"

// 倒计时
let secondsInterval: NodeJS.Timeout;

export type RegisterNoticeDialogProps = {
    open: boolean;
    onClose: () => void;
};

const RegisterNoticeDialog: React.FC<RegisterNoticeDialogProps> = (props) => {
    const [seconds, setSeconds] = useState(5);

    useEffect(() => {
        // 画面退出销毁倒计时
        return () => {
            if (secondsInterval) {
                clearInterval(secondsInterval);
            }
        }
    }, []);

    useEffect(() => {
        if (props.open) {
            setSeconds(5);
            secondsInterval = setInterval(() => {
                setSeconds(seconds => seconds - 1);
            }, 1000);
        }
    }, [props.open]);

    useEffect(() => {
        if (seconds <= 0) {
            clearInterval(secondsInterval);
        }
    }, [seconds])

    return (
        <Dialog fullScreen={true} open={props.open} onClose={() => props.onClose()}>
            <DialogTitle>
                <div>访客入厂安全培训与测试</div>
                <div>Albemarle Sichuan Site safety training & test for visitors</div>
            </DialogTitle>
            <DialogContent className={'mobile-register-notice-container'}>
                <div className={'mobile-register-notice-panel'}>
                    <div className={'mobile-register-notice-content'}>
                        <div>
                            <div>1、在进入到生产厂区前，请确保您完成了本次培训并通过测试。</div>
                            <div>Before entering the plant, please ensure that you have completed this training and
                                passed the test.
                            </div>
                        </div>
                        <br/>
                        <div>
                            <div>2、进入生产区，请检查您的PPE是否满足要求。</div>
                            <div>Please check if your PPE meets the requirements when entering the production area.
                            </div>
                        </div>
                        <br/>
                        <div>
                            <div>3、请确保您身边有雅保四川新材料员工的陪同。</div>
                            <div>Please ensure that you are accompanied by employees from Albemarle Sichuan New
                                Materials.
                            </div>
                        </div>
                        <br/>
                        <div>
                            <div>注：<span style={{color:'red'}}>访客培训记录一年内有效</span></div>
                            <div>Note: <span style={{color:'red'}}>Visitor training records are valid for one year.</span></div>
                        </div>
                    </div>
                </div>
                <div className={'mobile-register-notice-panel'}>
                    <div className={'mobile-register-notice-content'}>
                        <div>
                            <div>
                                在进入工厂前，您需要认真完成《承包商及访客入场须知》的培训和测试，并在工厂人员的陪同下，正确穿戴规定的PPE，方可进入生产区域。
                            </div>
                            <br/>
                            <div>
                                Before entering the factory, you need to carefully complete the training and testing
                                of
                                the "Contractor and Visitor Entry Notice", and wear the prescribed PPE correctly
                                with
                                the accompaniment of factory personnel before entering the production area.
                            </div>
                        </div>
                    </div>
                </div>
                <Button variant="contained" fullWidth={true} disabled={seconds > 0} onClick={() => props.onClose()}>
                    已阅读并同意/I have read and agree({seconds})
                </Button>
            </DialogContent>
        </Dialog>
    )
};

export default RegisterNoticeDialog;